/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RegionManager } from '@scenario/models/region-manager.model';
import { RootState } from '@store/create-store';
import {
  retrieveRegionManagersFailure,
  retrieveRegionManagersSuccess,
} from '@store/scenario/region-manager/region-manager-slice';

export const retrieveRegionManagersEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) => action$.pipe(
  ofType('regionManager/retrieveRegionManagers'),
  concatMap(() => from(dependencies.regionManagerGateway.retrieveAll()).pipe(
    map((regionManagers: RegionManager[]) => retrieveRegionManagersSuccess(regionManagers)),
    catchError(() => of(retrieveRegionManagersFailure('Failed to retrieve region managers'))),
  )),
);
